import React, { useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Table } from "@components/Table";
import { ButtonSecondary, ButtonPrimaryLink } from "@components/Button";
import { deleteSchoolPartnersById } from "@actions/schoolPartners.action";
import Modal from "@components/Modal";
import { Span } from "@styles/typography";
import { Row, Indent } from "@styles/grid";

const EditSchoolPartners = ({ schoolPartnersId }) => {
  const dispatch = useDispatch();
  const loading = useSelector(state => state.schoolsPartners.loading);

  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);

  const handleDeleteSchoolPartners = () => async () => {
    try {
      await dispatch(deleteSchoolPartnersById(schoolPartnersId));
      setIsRemoveModalOpen(false);
    } catch (error) {
      throw new Error(error.message);
    }
  };

  return (
    <Row justify="flex-end" padding="0 2rem 0 0">
      <Indent margin="0 1.5rem 0 0">
        <ButtonPrimaryLink uppercase href={`/schools-partners/${schoolPartnersId}`} outlined size="small" weight="bold">
          edit
        </ButtonPrimaryLink>
      </Indent>
      <ButtonSecondary uppercase onClick={() => setIsRemoveModalOpen(true)} size="small" weight="bold">
        Remove
      </ButtonSecondary>

      <Modal isOpen={isRemoveModalOpen} onClose={() => setIsRemoveModalOpen(false)} title="Remove Partner">
        <Indent margin="4rem 0">
          <Span size={1.8}>Are you sure you want to delete this school partners?</Span>
        </Indent>
        <Row justify="flex-end">
          <Indent margin="0 2rem 0">
            <ButtonSecondary outlined onClick={() => setIsRemoveModalOpen(false)} uppercase>
              Close
            </ButtonSecondary>
          </Indent>
          <ButtonSecondary autoFocus onClick={handleDeleteSchoolPartners()} uppercase disabled={loading}>
            Remove
          </ButtonSecondary>
        </Row>
      </Modal>
    </Row>
  );
};

const SchoolsPartnersTable = () => {
  const { all: schoolsPartners, fetching } = useSelector(({ schoolsPartners }) => schoolsPartners);

  const columns = useMemo(
    () => [
      {
        Header: "Partner School Id",
        accessor: "partner_school_id",
        isFiltered: true,
        isSorting: true,
      },
      {
        Header: "Partner",
        accessor: "partner.name",
        isFiltered: true,
        isSorting: true,
      },
      {
        Header: "School",
        accessor: "school.name",
        isFiltered: true,
        isSorting: true,
      },
      {
        id: "colEdit",
        Cell: ({ row }) => <EditSchoolPartners schoolPartnersId={row.original.id} />,
      },
    ],
    []
  );

  const data = useMemo(() => schoolsPartners, [schoolsPartners]);

  return <Table columns={columns} data={data} hasGlobalFilter loading={fetching} />;
};

export default SchoolsPartnersTable;
